import styled from 'styled-components';
import { COLOR_BLACK } from '@common/assets/styles/colors';
import PAGE_STYLES from '../../helpers/page-styles';

export default styled.div`
  ${PAGE_STYLES};

  .header {
    > h4 {
      font-weight: 700;
      line-height: 20px;
      text-align: center;
    }

    > span {
      margin-top: 16px;
      font-style: normal;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      display: block;
      color: ${COLOR_BLACK};
    }
  }
`;
